import * as yup from 'yup';
import { useYupValidationResolver } from '@shared/hooks/use-yup-validation-resolver.ts';

export const phoneSchema = yup.object({
  phone: yup
    .string()
    .min(18, 'Это поле обязательно для заполнения')
    .required('Это поле обязательно для заполнения'),
});

const otpSchema = yup.object({
  code: yup
    .string()
    .min(4, 'Это поле обязательно для заполнения')
    .required('Это поле обязательно для заполнения'),
});

export function usePhoneResolver() {
  return useYupValidationResolver(phoneSchema);
}

export function useOtpResolver() {
  return useYupValidationResolver(otpSchema);
}
